import type {SortConfig, SortDirection, SortField} from './PredictionBatchTypes';
import type {PredictionBatchSearchFilters} from './usePredictionBatchSearch';
import {DEFAULT_FILTERS} from './usePredictionBatchSearch';

const VALID_SORT_FIELDS: Set<string> = new Set(['createdAt', 'modifiedAt']);

export function readFiltersFromUrl(): PredictionBatchSearchFilters {
  const params = new URLSearchParams(window.location.search);

  return {
    query: params.get('q') ?? DEFAULT_FILTERS.query,
    creatorId: params.get('creator') || null,
    inputEntityId: params.get('inputEntity') || null,
  };
}

export function readSortFromUrl(): SortConfig {
  const params = new URLSearchParams(window.location.search);
  const sortParam = params.get('sort');
  if (sortParam) {
    const [field, dir] = sortParam.split(':');
    if (VALID_SORT_FIELDS.has(field)) {
      const direction: SortDirection = dir === 'asc' ? 'asc' : 'desc';
      return {
        key: field as SortField,
        direction,
      };
    }
  }
  return {key: 'createdAt', direction: 'desc'};
}

export function writeFiltersToUrl(filters: PredictionBatchSearchFilters, sort: SortConfig): void {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  // Preserve tab param
  if (filters.query) {
    params.set('q', filters.query);
  } else {
    params.delete('q');
  }

  if (filters.creatorId) {
    params.set('creator', filters.creatorId);
  } else {
    params.delete('creator');
  }

  if (filters.inputEntityId) {
    params.set('inputEntity', filters.inputEntityId);
  } else {
    params.delete('inputEntity');
  }

  params.set('sort', `${sort.key}:${sort.direction}`);

  window.history.replaceState(window.history.state, '', url.toString());
}

export function hasActiveFilters(filters: PredictionBatchSearchFilters): boolean {
  return filters.query !== '' || Boolean(filters.creatorId) || Boolean(filters.inputEntityId);
}
